"use client";

import { c as _c } from "react/compiler-runtime";
import { IconCircleCheck } from "central-icons/IconCircleCheck";
import { IconCircleX } from "central-icons/IconCircleX";
import { AnimatePresence, m } from "motion/react";
import { useState } from "react";
import DemoCheckbox from "@/components/preview/demo-checkbox";
import DemoFooter from "@/components/preview/demo-footer";
import DemoWrapper from "@/components/preview/demo-wrapper";
import { Button } from "@/components/ui/button";
import { SLIDE_HEIGHT } from "./slide-height";
export default function ShadowsView() {
  const $ = _c(14);
  const [showBackground, setShowBackground] = useState(false);
  let t0;
  if ($[0] !== showBackground) {
    t0 = showBackground && <m.div animate={{
      opacity: 1
    }} className="absolute inset-0 bg-linear-to-b from-gray-900 to-gray-800 will-change-[opacity]" exit={{
      opacity: 0
    }} initial={{
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: "easeOut"
    }} />;
    $[0] = showBackground;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <AnimatePresence>{t0}</AnimatePresence>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="pointer-events-none absolute inset-0 rounded-lg ring-1 ring-black/8 ring-inset dark:ring-white/8" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Button className="relative z-10 gap-2 border border-gray-400 bg-preview-bg pr-5 pl-3 text-lg shadow-none hover-hover:hover:border-gray-500 hover-hover:hover:bg-preview-bg" leftIcon={<div className="flex size-6 items-center justify-center rounded-full bg-gray-300"><IconCircleX className="size-4.5 text-gray-900" /></div>} rounded={true} size="xl" variant="secondary">Border</Button>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button className="relative z-10 gap-2 pr-5 pl-3 text-lg transition-[box-shadow,background-color,scale] duration-200 ease-out hover:bg-gray-200 hover:shadow-custom-hover" leftIcon={<div className="flex size-6 items-center justify-center rounded-full bg-sky-500/10"><IconCircleCheck className="size-4.5 text-sky-500" /></div>} rounded={true} size="xl" variant="secondary">Shadow</Button>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1) {
    t5 = <div className="h-full w-full px-1 pt-1"><div className="relative flex h-full w-full items-center justify-center gap-4 overflow-hidden rounded-lg">{t1}{t2}{t3}{t4}</div></div>;
    $[7] = t1;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== showBackground) {
    t6 = <DemoFooter className="border-none bg-preview-bg"><DemoCheckbox checked={showBackground} label="Show background" onCheckedChange={setShowBackground} /></DemoFooter>;
    $[9] = showBackground;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <DemoWrapper height={SLIDE_HEIGHT}>{t5}{t6}</DemoWrapper>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}